<template>
  <div class="index">
    <!-- 搜索框 -->
    <div class="search section">
      <van-search
        v-model="params.queryKey"
        background="#05D487"
        placeholder="请输入关键词"
        @search="onSearch"
        @cancel="onCancel"
      />
      <div class="mine" @click="onSearch()">
        <img src="./assets/images/search.png" alt="">
      </div>
    </div>

    <!-- 顶部横栏 -->
    <div class="topban section">
      <div class="logo">
        <img :src="(publicData.accountBasic.shareLogo && publicData.accountBasic.shareLogo!= 'undefined')?publicData.accountBasic.shareLogo:'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/ext/WechatIMG7286.png'" alt="">
      </div>
      <div class="info">
        <div class="title">{{(publicData.accountBasic.shareName && publicData.accountBasic.shareName!='undefined')?publicData.accountBasic.shareName:'希望保'}}</div>
        <div class="tip">{{(publicData.accountBasic.shareSlogan && publicData.accountBasic.shareSlogan!='undefined')?publicData.accountBasic.shareSlogan: '一个为企业降低风险的平台'}}</div>
      </div>
      <div class="btns">
        <!-- <div class="btn">去官网</div> -->
      </div>
    </div>

    <!-- banner -->
    <div class="banner section">
      <img :style="{height:posterHeight+'px'}" src="./assets/images/banner.png" alt="">
    </div>

    <!-- 保险列表块 -->
    <div class="pro-list section">
      <div class="titel"><div class="shu"></div>保险超市</div>
      <div class="tabs">
        <!-- <van-tabs @click="onClickTab" color="#05D487">
          <van-tab v-for="(item,index) in level2Types" :key="index" :title="item.name">
            </van-tab>
        </van-tabs> -->
          <div class="select-box">
            <van-dropdown-menu>
              <van-dropdown-item @change="changeClassifies" v-model="selectModel.age" :options="typeList" />
              <van-dropdown-item @change="changeTag" v-model="selectModel.tag" :options="tagList" />
              <!-- <van-dropdown-item @change="changeAge" v-model="selectModel.age" :options="ageList" /> -->
              <van-dropdown-item @change="changePrice" v-model="selectModel.death" :options="deathGuarantee" />
              <van-dropdown-item @change="changeCom" v-model="selectModel.company" :options="companys" />
            </van-dropdown-menu>
          </div>
      </div>

      <div class="list-content">
        <div class="item" v-for="(item,index) in products.list" :key="index" @click="gotoDetail(item)"  v-if="item.isClose!==1">
          <div class="poster">
            <img :src="item.poster" alt="">
          </div>
          <div class="info">
            <div class="titel">
              {{item.title}}
            </div>
            <div class="company">本保险由{{item.insuranceCompany}}承保</div>
            <div class="age">投保年龄:{{item.fromAge}}-{{item.endAge}}周岁</div>
            <div class="money">保额: <span style="color:#00d385" :style="{color:(!!publicData && publicData.isShare) ? publicData.accountBasic.shareColor:'#00d385'}">{{item.fromPrice | countFilter}} - {{item.endPrice | countFilter}}</span></div>
            <div class="price-box">
              <div class="price" v-if="item.plans[0].cycle[0]"><span style="font-size:20px">¥</span>{{item.plans[0].cycle[0].price}} <span style="font-size:12px">起</span></div>
              <div style="color:red" v-if="item.isClose==2">
                <span>暂停购买</span>
              </div>
              <div class="btns" v-else>
                <span>立即投保</span>
                <img src="./assets/images/jiantou.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <van-empty v-if="noData" description="暂时没有该类数据～～" />
      </div>
      <div class="order_list" @click="gotoOrder()">
        <van-icon name="orders-o" size="16" color="#07c160" />
        保单查询
      </div>
    </div>
  </div>
</template>

<script>
import { Search,Toast,Tab, Tabs,DropdownMenu, DropdownItem,Empty,Icon } from 'vant';
import wechatService from '@/services/request/wechatService.js'
import storejs from "store";

export default {
  name: 'Index',
  components: {
    [Search.name]: Search,
    [Toast.name]:Toast,
    [Tab.name]:Tab,
    [Tabs.name]:Tabs,
    [DropdownMenu.name]:DropdownMenu,
    [DropdownItem.name]:DropdownItem,
    [Empty.name]:Empty,
    [Icon.name]:Icon
  },
  data() {
    return {
      publicData: storejs.get("publicData"),
      params:{
        queryKey:'',
        pageSize:10,
        pageNumber:1
      },
      noData:false,
      isLoading:false,
      tagList:[],
      companys:[],
      products:{
        list:[]
      },
      typeList:[],
      level2Types:[],
      selectModel:{
        age:0,
        death:0,
        company:'',
        classifie:0,
        tag:''
      },
      ageList:[
        {
          value:0,
          text:"年龄:不限"
        },
        {
          value:1,
          text:"年龄:0-10周岁"
        },
        {
          value:2,
          text:"年龄:10-20周岁"
        },
        {
          value:3,
          text:"年龄:20-50周岁"
        },
        {
          value:4,
          text:"年龄:50-100周岁"
        }
      ],
      deathGuarantee:[//身故保障选择数据
        {
          value:0,
          text:'保额:不限'
        },
        {
          value:1,
          text:'保额:10-20万'
        },
        {
          value:2,
          text:'保额:20-50万'
        },
        {
          value:3,
          text:'保额:50以上'
        },
        // {
        //   value:4,
        //   text:'保额:50-100万'
        // },
        // {
        //   value:5,
        //   text:'保额:100以上'
        // },
      ],
      posterHeight:190,
      timeOut:'',
      unionId:'',
      openId:''
    }
  },
  created() {
    if(!this.publicData){
      this.$router.push({
        name:'Login'
      })
    }
  },
  watch: {
    'params.queryKey':function(val) {//关键字搜索
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(async () => {
        this.products.list = []
        this.params.pageNumber = 1
        this.getProducts()  
      }, 500);
    },
  },
  mounted() {
    console.log('publicData',this.publicData)
    document.title = this.publicData.accountBasic.shareName
    this.init()
  },
  beforeDestroy: function() {
    window.removeEventListener('scroll', this.scroll)
    // this.scroll = null
  },
  methods: {
    changeClassifies(value){
      console.log('value',value)
      this.products.list = []
      this.params.pageNumber = 1
      this.params.classify = value
      if(this.params.classify == 0){
        this.params.classify = ''
      }
      this.getProducts()
    },
    gotoOrder(){
      this.$router.push({
        name:'CpsOrder',
        query:{
          c:this.$route.query.c
        }
      })
    },
    changeTag(value){
      this.products.list = []
      this.params.pageNumber = 1
      this.params.tags = value
      if(this.params.tags == 0){
        this.params.tags = ''
      }
      this.getProducts()
    },
    changeAge(value){
      console.log('value',value)
      let item = this.ageList[value].text
      item = item.split(':')
      console.log('item',item)
      let ages = item[1].substring(0,item[1].length-2)
      ages = ages.split('-')
      console.log('item',ages)
      if(ages[0] == '不'){
        this.params.ageStart = ''
        this.params.ageEnd = ''
      }else{
        this.params.ageStart = ages[0]
        this.params.ageEnd = ages[1]
      }
      this.products.list = []
      this.params.pageNumber = 1
      this.getProducts()
    },
    changePrice(value){
      console.log(value)
      let item = this.deathGuarantee[value].text
      item = item.split(':')
      console.log('item',item)
      let ages = item[1].substring(0,item[1].length-1)
      ages = ages.split('-')
      console.log('item',ages)
      if(ages[0] == '不'){
        this.params.limitStart = ''
        this.params.limitEnd = ''
      }else{
        if(ages[0].indexOf('以')!= -1){
          this.params.limitStart =50 + '0000'
          this.params.limitEnd = ''
        }else{
          this.params.limitStart = ages[0]+ '0000'
          this.params.limitEnd = ages[1] + '0000'
        }
        
      }
      this.products.list = []
      this.params.pageNumber = 1
      this.getProducts()
    },
    changeCom(value){
      console.log(value)
      if(value == ''){
         this.params.insuranceCompanyId = ''
      }else{
        this.params.insuranceCompanyId = value
      }
      this.products.list = []
      this.params.pageNumber = 1
      this.getProducts()
    },
    onSearch(val) {
      this.products.list = []
      this.params.pageNumber = 1
      this.getProducts()
      // Toast(val);
    },
    onCancel() {
      // Toast('取消');
    },
    onClickTab(name, title) {
      if(title!='全部'){
        this.params.classify = title
      }else{
        this.params.classify = ''
      }
      this.products.list = []
      this.params.pageNumber = 1
      this.getProducts()
      // this.$toast(title);
    },
    gotoDetail(item){
      this.$router.push({
        name:'Detail',
        query:{
          id:item.uniqId,
          c:this.$route.query.c
        }
      })
    },
    shareConfig(){

      console.log('wxShareConfig',wxShareConfig)
      // console.log(this.publicData.accountBasic.shareUrl)
      let shareUrl = ''
      let wxShareConfig = {}
      console.log('this.publicData',this.publicData)
      if(this.publicData.accountBasic.shareUrl){
        wxShareConfig = {
          title: this.publicData.accountBasic.shareName || '希望保',
          desc: this.publicData.accountBasic.shareSlogan || '一个为企业降低风险的平台',
          imgUrl: this.publicData.accountBasic.shareLogo || 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/ext/icon.png',
          link: "http://cps1.baojbx.com/index?c=" + this.publicData.accountBasic.shareUrl
        }
      }else{
        wxShareConfig = {
          title: this.publicData.accountBasic.shareName || '希望保',
          desc: this.publicData.accountBasic.shareSlogan || '一个为企业降低风险的平台',
          imgUrl: this.publicData.accountBasic.shareLogo || 'https://fimage.oss-cn-shenzhen.aliyuncs.com/common/ext/icon.png',
          link: location.href
        }
      }
      console.log('wxShareConfig',wxShareConfig)
      wechatService.jsapi(0, wxShareConfig, ['onMenuShareTimeline', 'onMenuShareAppMessage'])
    },
    async init(){
      let width = window.innerWidth
      let height = width
      this.posterHeight = height*0.29
      if(location.href.indexOf('http://localhost') != -1){

      }else if(this.$page.isInWechat){
        wechatService.auth(0, ({
        openid, unionid
        }) => {
          if(!!openid && !!unionid) {
            this.unionId = unionid
            this.openId = openid
            this.shareConfig()     
          }
        }, false)
      }
      await this.getTags()
      await this.getCompanys()
      await this.getTypes()
      await this.getProducts()
      window.addEventListener('scroll', this.scroll)
    },
    async getTags(){
      let res = await this.$http.post("api/insuranceProduction/getTags", {}); 
      console.log('标签',res)
      if(res.code == 0){
        
        try {
          let list = res.t
          list = list.filter(function (s) {
            return s && s.trim(); // 注：IE9(不包含IE9)以下的版本没有trim()方法
        })
          let newList = [{
            value:'',
            text:"标签:不限"
          },]
          list.forEach((el)=>{
            let obj ={
              value:el,
              text:'标签:'+el
            }
            newList.push(obj)
          })
          this.tagList = newList
          console.log('this.tagList',this.tagList)
          // res.t.unshift('不限')
          // this.tagList = res.t

        } catch (error) {
          this.tagList = []
        }
      }else{
        this.$toast.fail(res.msg);
      }
    },
    async getTypes(){
      let res = await this.$http.post("api/insuranceComponay/getClassifies", { 
          
      }); 
      console.log('分类',res)
      if(res.code == 0){
        
        try {
          let list = JSON.parse(res.t)
          let newList = [{
            value:0,
            text:"类别:不限"
          },]
          list.forEach((el)=>{
            let obj ={
              value:el.name,
              text:'类别:'+el.name
            }
            newList.push(obj)
          })
          this.typeList = newList
          console.log('this.typeList',this.typeList)
          // this.typeList = JSON.parse(res.t)
          // let level2 = []
          // this.typeList.forEach((item,index)=>{
          //   if(item.children.length){
          //     item.children.forEach((el,i)=>{
          //       level2.push(el)
          //     })
          //   }
          // })
          // level2.unshift({
          //   id:'',
          //   level:2,
          //   name:'全部'
          // })
          // this.level2Types = level2
        } catch (error) {
          this.typeList = []
        }
         console.log(this.typeList)
      }else{
        this.$toast.fail(res.msg);
      }
    },
    async getProducts(){
      if(this.isLoading) return
      this.isLoading = true
      this.noData = false
      this.params.accountId = this.publicData.accountBasic.accountId
      this.params.isCps = 1
      let res = await this.$http.post("api/insuranceProduction/getList", this.params); 
      console.log('产品',res)
      if(res.code!=502 && res.list.length>0){
        res.list.forEach(el=> {
        
          el.planIndex = 0
          try {
            el.summarys = JSON.parse(el.summarys)
            el.plans = JSON.parse(el.plans)
          } catch (error) {
            el.plans = []
            el.summarys = []
          }
          
        });
        // this.products = res
        this.products.list = [...this.products.list,...res.list]
        this.params.pageNumber ++
        
      }else{
        if(this.params.pageNumber == 1){
          this.products.list = []
          this.noData = true
        }
      }
      this.isLoading = false
    },
    async getCompanys(){
      let res = await this.$http.post("api/insuranceComponay/getList", {
        queryKey:'',
        pageNumber:1,
        pageSize:40,
        accountId:this.publicData.id
      }); 
        console.log('公司',res)
        try {
           res.list.unshift({
              name:'不限'
            })
            let companys = []
            res.list.forEach((item,index)=>{
              let obj = {
                value:!!item.id?item.id:'',
                text:'公司:' + item.name
              }
              companys.push(obj)
            })
            this.companys = companys
        } catch (error) {
          
        }
    },
    scroll() {//也有效
      let wScrollY = window.scrollY; // 滚动条位置
      let WInnerH = window.innerHeight // 设备窗口的高度
      var bScrollH = document.body.scrollHeight;  //  滚动条的总高度
      if (wScrollY + WInnerH >= bScrollH-50) {          
        // this.params.pageNumber ++
        this.getProducts()
      
      }  
      // let scrollTop = $(window).scrollTop();
      // let scrollHeight = $(document).height();
      // let windowHeight = $(window).height();
      // if(scrollTop + windowHeight == scrollHeight){
      //     alert(66)
      //     this.params.pageNumber ++
      //     this.getOrderList()
      // }
		},
  },
}
</script>

<style lang="scss" scoped>
  .index{
    .search{
      display: flex;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1000;
     .van-search__content{
        background:rgba(226,254,247,1);
      }
      .van-icon-search{
        color: red;
      }

      .van-search{
        flex: 1;
        height: .5rem;
      }

      .mine{
        width: .5rem;
        height: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #05D487;
        img{
          width: .2rem;
          height: .2rem;
        }
      }
      
    }

    .topban{
      width: 100%;
      height: 1rem;
      padding: 0 .12rem;
      box-sizing: border-box;
      display: flex;
      background:rgba(255,255,255,0.89);
      padding-top: .5rem;
      .logo{
        width: .5rem;
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: .1rem;
        img{
          width: .35rem;
          height: .35rem;
        }
      }
      .info{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .title{
          font-size: 0.13rem;
          font-size:14px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(51,51,51,1);
          color:rgba(51,51,51,1);
          line-height:20px
        }
        .tip{
          font-size: .12rem;
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(142,142,142,1);
          transform: scale(.9); transform-origin: left
        }
      }
      .btns{
        width: .6rem;
        line-height: 50px;
        flex-shrink: 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .btn{
          font-size: .12rem;
          color: #fff;
          height:.3rem;
          background:rgba(5,212,135,1);
          border-radius:4px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          width: .5rem;
        }
      }
    }

    .banner{
      width: 100%;
      display: flex;
      img{
        width: 100%;
      }
    }

    .pro-list{
      padding: 15px;
       box-sizing: border-box;
      .titel{
        display: flex;
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
        align-items: center;
        // height: 30px;
        line-height: 1.1;
        .shu{
          width: 2px;
          background: #00D385;
          height: 12px;
          margin-right: 5px;
        }
      }
      .tabs{
        .van-hairline--top-bottom::after{
          border-width:0 0 !important;
        }
      }
      .list-content{
        width: 100%;
        .item{
          background:rgba(255,255,255,1);
          box-shadow:0px 2px 5px 1px rgba(0,0,0,0.05);
          border-radius:8px;
          padding: .1rem;
          display: flex;
          margin-bottom: 10px;
          .poster{
            height: 1rem;
            flex-shrink: 0;
            img{
              height: 100%;
            }
          }
          .info{
            font-size: 14px;
            flex: 1;
            padding-left: 10px;
            box-sizing: border-box;
            .title{
              font-size:14px;
              font-family:PingFangSC-Medium,PingFang SC;
              font-weight:500;
              color:rgba(51,51,51,1);
            }
            .company{
              margin-top: 6px;
              font-size:12px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(102,102,102,1);
              // line-height: 20px;
            }
            .age{
              font-size:13px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(153,153,153,1);
              line-height: 20px;
            }
            .money{
              font-size:13px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(153,153,153,1);
              line-height: 20px;
            }
            .price-box{
              margin-top: 2px;
              display: flex;
              justify-content: space-between;
              .price{
                color: #FF1010;
              }
              .btns{
                font-size: 13px;
                display: flex;
                align-items: center;
                span{
                  margin-right: 5px;
                  color: #00D385;
                }
                img{
                  width: 13px;;
                }
              }
            }
          }
        }
      }
    }
    
  }
  .order_list{
    position: fixed;
    bottom: 40px;
    right: 12px;
    z-index: 100;
    font-size: 14px;
    display: flex;
    align-items: center;
    background: white;
    box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.3);
    padding: 5px 8px;
    border-radius: 4px;
  }
</style>

<style lang="scss">
.index{
  .search{
    .van-search__content{
      background:rgba(226,254,247,1);
      border-radius:6px;
    }
    .van-icon-search{
      color: rgba(186,186,186,1);;
    }
  }
  .tabs{
    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
     border-width: 0;
    }
    .van-tab--active{
      color: #00D385;
    }
    .select-box{
      .van-dropdown-menu__bar{
        box-shadow:none
      }
      .van-dropdown-menu__title--active{
        color: #00D385;
      }
      .van-cell__value{
        max-width: 40px;
      }
      .van-dropdown-item__option--active{
        color: #00D385;
      }
      .van-dropdown-item__option--active .van-dropdown-item__icon{
        color: #00D385;
      }
      .van-ellipsis{
        font-size: 12px;
      }
    }
  }
}
  
</style>
